import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { H5, Box } from "@appcues/component-library";
import ThemeEditSection from "components/Themes/ThemeEdit/ThemeEditTab/ThemeEditSection";

const ThemeEditTab = ({ sections, draftTheme, setDraftTheme }) => {
  return (
    <div>
      {sections.map(section => (
        <Box key={section.title} paddingBottom={24}>
          <StyledContainer>
            <H5 type="primary">{section.title}</H5>
          </StyledContainer>
          <ThemeEditSection
            contentArray={section.options}
            draftTheme={draftTheme}
            setDraftTheme={setDraftTheme}
          />
        </Box>
      ))}
    </div>
  );
};

ThemeEditTab.propTypes = {
  sections: PropTypes.array.isRequired,
  draftTheme: PropTypes.object.isRequired,
  setDraftTheme: PropTypes.func.isRequired
};

export default ThemeEditTab;

const StyledContainer = styled.div`
  margin-top: 20px;
  border-bottom: 1px solid ${props => props.theme["$gray-2"]};
`;
